import { select } from 'redux-saga/effects';
import {
  readStateBoard,
  readStateUser,
} from '../state';
import updateBoardService from './services/board/updateBoard';

export default function* saveBoardSettings() {
  try {
    const user = yield select(readStateUser);
    const board = yield select(readStateBoard);

    const boardSettings = { // isolate board properties relevant to share settings
      id: board.id,
      share_type: board.share_type,
      properties: board.properties,
      share_details: board.share_details,
      public_id: board.public_id,
    };

    yield updateBoardService({
      user: user.userId,
      domain: user.domain,
      board: boardSettings,
    });
  } catch (error) {
    console.error(error);
  }
}
